export interface AboutInfo {
  brandName: string;
  brandIntro: string;
  mission: string;
  vision: string;
  values: { title: string; description: string; icon: string }[];
  milestones: { year: string; title: string; description: string }[];
  teamMembers: { name: string; role: string; bio: string; imageSeq: string }[];
  contactInfo: {
    address: string;
    phone: string;
    email: string;
    wechat: string;
    workHours: string;
  };
  certifications: { name: string; description: string }[];
  stats: { label: string; value: string; icon: string }[];
}

export const aboutInfo: AboutInfo = {
  brandName: '膀胱健康管理网',
  brandIntro: '膀胱健康管理网（Bladder Health China）是国内领先的膀胱健康与排尿管理科普平台。我们汇聚了来自三甲医院泌尿外科、康复医学科、妇产科及营养科的多学科专家团队，致力于为公众提供专业、科学、实用的膀胱控制训练知识与健康管理方案。自2020年创立以来，已累计服务超过50万用户，发布原创科普文章200余篇，帮助无数受尿频、尿失禁等问题困扰的用户重获生活品质。',
  mission: '以循证医学为基础，以用户体验为核心，让每一个受泌尿健康问题困扰的人都能获得科学、可靠、可操作的健康管理方案。',
  vision: '成为中国最受信赖的膀胱健康科普平台，推动全民泌尿健康素养的提升，让"盆底健康"像"牙齿健康"一样成为公众日常关注的一部分。',
  values: [
    { title: '科学严谨', description: '所有内容均经过医学专家审核，基于循证医学证据', icon: 'ri-microscope-line' },
    { title: '用户至上', description: '以用户的真实需求为出发点，提供个性化的健康方案', icon: 'ri-user-heart-line' },
    { title: '隐私保护', description: '严格保护用户健康数据，绝不泄露任何个人信息', icon: 'ri-shield-check-line' },
    { title: '持续创新', description: '不断引入新的研究成果和技术手段，优化服务质量', icon: 'ri-lightbulb-flash-line' },
  ],
  milestones: [
    { year: '2020年3月', title: '平台创立', description: '由三位三甲医院泌尿外科医生共同发起，以微信公众号形式开始运营' },
    { year: '2021年6月', title: '官网正式上线', description: '推出独立官方网站，提供更加系统的健康科普内容和在线自测工具' },
    { year: '2022年9月', title: '专家团队扩展', description: '邀请康复医学、营养学、心理学等多学科专家加入，形成跨学科健康管理团队' },
    { year: '2023年12月', title: '用户突破50万', description: '累计服务用户超过50万，成为国内膀胱健康领域的头部科普平台' },
    { year: '2024年5月', title: '线上训练课程上线', description: '推出系列化的线上膀胱训练视频课程，用户可在家自主进行科学训练' },
    { year: '2025年8月', title: 'AI辅助评估系统', description: '上线人工智能辅助的膀胱健康初步评估系统，提升用户自我监测效率' },
  ],
  teamMembers: [
    { name: '李明辉', role: '创始人 / 泌尿外科主任医师', bio: '北京协和医院泌尿外科主任医师，博士生导师。从事泌尿外科临床工作25年，专长于下尿路功能障碍的诊疗与康复。', imageSeq: 'team-li' },
    { name: '王芳', role: '联合创始人 / 康复医学主任医师', bio: '上海华山医院康复医学科主任医师，擅长盆底功能障碍的康复治疗与训练方案设计，发表SCI论文40余篇。', imageSeq: 'team-wang' },
    { name: '赵雪', role: '医学顾问 / 解剖学教授', bio: '北京大学医学部解剖学教授，专注于盆底功能解剖学研究，主编《盆底功能解剖与临床》等多部教材。', imageSeq: 'team-zhao' },
    { name: '张蕾', role: '营养学顾问 / 临床营养科主任', bio: '浙江大学附属第一医院临床营养科主任，擅长泌尿系统疾病的营养干预与膳食管理。', imageSeq: 'team-zhang' },
  ],
  contactInfo: {
    address: '北京市海淀区中关村南大街5号院卫生健康大厦1206室',
    phone: '400-888-6789',
    email: 'contact@bladderhealth.cn',
    wechat: 'BladderHealth-China',
    workHours: '周一至周五 9:00-18:00（法定节假日除外）',
  },
  certifications: [
    { name: '互联网医疗健康科普资质认证', description: '经国家卫生健康委员会认证的健康科普平台' },
    { name: '中国医师协会科普分会会员单位', description: '积极参与医学健康知识的社会化普及工作' },
    { name: 'ISO 27001信息安全管理体系认证', description: '用户健康数据管理符合国际信息安全标准' },
  ],
  stats: [
    { label: '服务用户', value: '50万+', icon: 'ri-user-line' },
    { label: '原创文章', value: '200+', icon: 'ri-article-line' },
    { label: '专家团队', value: '30+', icon: 'ri-team-line' },
    { label: '满意度', value: '98.5%', icon: 'ri-emotion-happy-line' },
  ],
};